import { ExternalLink, Smartphone } from "lucide-react";

export const AdminEmployeeLauncher = () => (
    <a href="/system/medarbejder" target="_blank" rel="noopener noreferrer" data-testid="admin-open-employee-system"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-blue-200 bg-blue-50 text-blue-700 text-sm font-semibold hover:bg-blue-100 transition-colors">
        <Smartphone className="w-4 h-4 shrink-0" /> Åbn medarbejdersystem <ExternalLink className="w-4 h-4 shrink-0" />
    </a>
);